import React from 'react';
import { Box, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { PDFPage } from './PDFPage.component';
import { PDFDocumentProxy } from 'pdfjs-dist';


const useStyles = makeStyles<Partial<PDFPaginationProps>>({ name: 'PDFPagination' })(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    userSelect: 'none',
  },
  item: {
    display: 'flex',
    flexDirection: 'column',
    gap: '5px',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
  },
  itemPreview: {
    maxWidth: '96px',
    display: 'flex',
    borderRadius: '4px',
    overflow: 'hidden',
    border: '1px solid transparent',
  },
  itemPreviewSelected: {
    border: '1px solid #757575',
  }
}));


export type PDFPaginationProps = {
  pdf: PDFDocumentProxy;
  pageNumber: number;
  setPage: (page: number) => void;
  classes?: Partial<typeof useStyles>;
};


export const PDFPagination: React.VFC<PDFPaginationProps> = ({ pdf, pageNumber, setPage, ...props }) => {
  const { classes, cx } = useStyles(props, { props });
  const pages = React.useMemo(() => Array.from({ length: pdf.numPages }).map((_, index) => index), [ pdf ]);

  return (
    <Box className={classes.root}>
      {pages.map((index) => {
        const selected = pageNumber === index;

        return (
          (
            <Box
              key={index}
              className={classes.item}
              onClick={() => setPage(index)}
            >
              <React.Suspense fallback={null}>
                <Box
                  className={cx(classes.itemPreview, {
                    [classes.itemPreviewSelected]: selected,
                  })}
                >
                  <PDFPage pdf={pdf} pageNumber={index} />
                </Box>
                <Typography>Page {index + 1}</Typography>
              </React.Suspense>
            </Box>
          )
        );
      })}
    </Box>
  );
};
